import React, { useEffect, useRef, useState } from "react";
import "./signup.css";
import subLogo from "../../../assets/signupImage.png";
import asscentsLogo from "../../../assets/Loginlogo.png";
import eyeOn from "../../../assets/eye-on.svg";
import eyeOff from "../../../assets/eye-off.svg";
import eyeDead from "../../../assets/eyedead.svg";
import { Field, Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import ErrorMsg from "../../../components/form/errorMsg";
import { useDispatch } from "react-redux";
import { signup } from "../../../redux/actions/authActions";
import { Spinner } from "react-bootstrap";
import SuccessPopup from "../../../components/Popups/SuccessPopUp";
import ErrorPopup from "../../../components/Popups/ErrorPopup";

const Signup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [submitDisable, setSubmitDisable] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState('');

  const passwordRegex =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  const initialValues = {
    email: "",
    password: "",
    confirm_password: "",
  };

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmViewPassword, setConfirmViewPassword] = useState(false);

  const [passwordDisable, setPasswordDisable] = useState(false);
  const [confirmPasswordDisable, setConfirmPasswordDisable] = useState(false);

  const loginSchema = Yup.object().shape({
    email: Yup.string().email().required("Required"),
    password: Yup.string("")
      .matches(passwordRegex, "Password criteria not matching")
      .trim()
      .required("Password is required"),
    confirm_password: Yup.string()
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Your password didn't match"
        ),
      })
      .required("Confirm password is required"),
  });

  const onSubmit = (values, { resetForm }) => {
    console.log(values);
    setLoading(true);
    setSubmitDisable(true);
    dispatch(
      signup(
        values.email,
        values.password,
        values.confirm_password,
        onSuccess,
        onError
      )
    );
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    setLoading(false);
    setSubmitDisable(false);
    navigate("/email-verification-send");
  }

  const onSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const message = (data.data.message);
    const msg_updated = message.charAt(0).toUpperCase() + message.slice(1);
    setShowSuccessMsg(msg_updated);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
    setSubmitDisable(false);
    setLoading(false);
  }

  const onError = (err) => {
    setShowErrorPopup(true)
    const str = (err.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    formRef?.current?.setFieldError("email", err?.data?.errors?.email);
    formRef?.current?.setFieldError("password", err?.data?.errors?.password);
    formRef?.current?.setFieldError(
      "confirm_password",
      err?.data?.errors?.confirm_password
    );
  };

  const handleChange1 = (e) => {
    if (e.target.value.length > 0) {
      setPasswordDisable(true);
    } else {
      setPasswordDisable(false);
    }
  };

  const handleChange2 = (e) => {
    if (e.target.value.length > 0) {
      setConfirmPasswordDisable(true);
    } else {
      setConfirmPasswordDisable(false);
    }
  };

  const FormEnableCheck = () => {
    const {
      values: { email, password, confirm_password },
    } = useFormikContext();
    useEffect(() => {
      if (
        email.trim() != "" &&
        password.trim() != "" &&
        confirm_password.trim() != ""
      ) {
        setDisable(false);
      } else {
        setDisable(true);
      }
    }, [email, password, confirm_password]);
    return null;
  };

  return (
    <div className="signup-container fn_Nunito d-flex flex-column flex-lg-row justify-content-center">
      <div className="">
        <img
          src={asscentsLogo}
          alt="website logo"
          className="asscents-logo-image d-lg-none"
        />
      </div>
      <div className="left-view pb-4 mt-4 pb-lg-0  d-flex flex-column justify-content-center">
        <img
          src={subLogo}
          alt="Asscents Website"
          className="signup-img align-self-center"
        />
      </div>
      <div className="right-view justify-content-center d-flex flex-column mt-5 pt-4 pt-lg-0 mt-lg-0">
        <div className="form-container align-self-center  d-flex justify-content-around m-0 flex-column">
          <img
            src={asscentsLogo}
            alt="website logo"
            className="asscents-logo-image d-none d-lg-block "
          />
          <Formik
            initialValues={initialValues}
            validationSchema={loginSchema}
            onSubmit={onSubmit}
            innerRef={formRef}
          >
            <Form>
              <FormEnableCheck />
              <h1 className="fw_700 fs_22 mt-3">Sign Up</h1>
              <div className="w-100 mt-3">
                <label className="w-100 mx-1 label-input">Email Address</label>
                <Field name={"email"}>
                  {({ field, meta }) => (
                    <input
                      {...field}
                      placeholder="Enter your email address"
                      id={"email"}
                      className={"w-100 input-field"}
                    />
                  )}
                </Field>
                <ErrorMsg name="email" />
              </div>
              <div className="w-100 mt-lg-0">
                <label className="w-100 mx-1 label-input">Password</label>
                <Field name={"password"}>
                  {({ field, meta }) => (
                    <div className="position-relative">
                      <input
                        {...field}
                        placeholder="Enter your password"
                        id={"password"}
                        type={passwordVisible ? "text" : "password"}
                        className={"w-100 input-field"}
                        onKeyUp={(e) => handleChange1(e)}
                      />
                      <img
                        className="signup_password_eye__icon cursor_pointer"
                        onClick={() => setPasswordVisible(!passwordVisible)}
                        src={
                          passwordDisable
                            ? passwordVisible
                              ? eyeOn
                              : eyeOff
                            : eyeDead
                        }
                        alt="show password or not"
                      />
                    </div>
                  )}
                </Field>
                <ErrorMsg name="password" />
              </div>
              <div className="w-100 mt-lg-0">
                <label className="w-100 mx-1 label-input">
                  Confirm Password
                </label>
                <Field name={"confirm_password"}>
                  {({ field, meta }) => (
                    <div className="position-relative">
                      <input
                        {...field}
                        placeholder="Re-enter your password"
                        id={"confirmPassword"}
                        type={confirmViewPassword ? "text" : "password"}
                        className={"w-100 input-field"}
                        onKeyUp={(e) => handleChange2(e)}
                      />
                      <img
                        className="signup_password_eye__icon cursor_pointer"
                        onClick={() =>
                          setConfirmViewPassword(!confirmViewPassword)
                        }
                        src={
                          confirmPasswordDisable
                            ? confirmViewPassword
                              ? eyeOn
                              : eyeOff
                            : eyeDead
                        }
                        alt="show password or not"
                      />
                    </div>
                  )}
                </Field>
                <ErrorMsg name="confirm_password" />
              </div>
              <button
                className="signup-button"
                type="submit"
                disabled={disable || submitDisable}
              >
                {loading && <Spinner size="sm" />} Signup
              </button>
              <p className="support-element">
                Do you have an account?{" "}
                <span
                  onClick={() => navigate("/login")}
                  className="span-support cursor_pointer"
                >
                  Login
                </span>
              </p>
            </Form>
          </Formik>
          <SuccessPopup
            show={showSuccessPopup}
            title={showSuccessMsg}
          />
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default Signup;
